import React from 'react'
import ListaDePrecios from '../../Componentes/ListaDePreciosPrincipal'
import './estilos.css';

function ListaDePreciosPage() {
    
    return (
        <div className='cont-lista-precio-page'>
            <ListaDePrecios />
        </div>
    )
}

export default ListaDePreciosPage